import { Typography } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import colors from '../../theme/colors'

export function AccordionComponent({ title, text }) {
    return (
        <Accordion variant="GeneralAccordion" >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: colors.primary }} />}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>
                    {text}
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
}
